import React, { useEffect, useState } from "react"; // Removed unused useMemo
import { getNextPrayerOrJummah } from "../../utils/prayerUtils";

const getOrdinal = (n) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

const JummahInfo = ({ prayerData = {}, colorSettings = {}, timezone, currentTime }) => {
  const {
    headerBackgroundColor = "#182E1E",
    headerTextColor = "#FFFFFF",
    highlightColor = "#D39B51",
  } = colorSettings;

  const [jummahTimes, setJummahTimes] = useState([]);
  const [nextJummah, setNextJummah] = useState(null);

  useEffect(() => {
    if (Array.isArray(prayerData?.jummahTimes)) {
      const sorted = prayerData.jummahTimes.sort((a, b) => a.sequence - b.sequence);
      setJummahTimes(sorted);
    } else {
      setJummahTimes([]);
    }
  }, [prayerData]);

  useEffect(() => {
    if (!jummahTimes.length || !currentTime || !timezone) return;

    const next = getNextPrayerOrJummah(currentTime, prayerData.iqamatimes, jummahTimes, 0);

    if (next && next.type === "jummah") {
      setNextJummah(next);
    } else {
      setNextJummah(null);
    }
  }, [currentTime, timezone, jummahTimes, prayerData.iqamatimes]);

  const formatApiTime = (timeStr) => {
    if (!timeStr) return { cleanTime: "--:--", meridiem: "" };
    const [time, meridiem] = timeStr.split(" ");
    return { cleanTime: time.replace(/^0/, ""), meridiem };
  };

  const renderJummahBlock = (entry) => {
    const khutbah = formatApiTime(entry.khutba_Time);
    const iqamah = formatApiTime(entry.iqama_Time);
    
    const isNext = nextJummah?.type === "jummah" && entry.sequence === nextJummah.sequence;

    return (
      <div
        key={entry.sequence}
        className={`flex flex-col items-center justify-center rounded-lg p-[1svh] shadow transition-all duration-300 ${
          isNext ? "scale-[1.03] ring-2 ring-yellow-400" : ""
        }`}
        style={{
          backgroundColor: isNext ? highlightColor : headerBackgroundColor,
          color: headerTextColor,
        }}
      >
        <p className="text-[3.8svh]">
          {getOrdinal(entry.sequence)}
        </p>

        <div className="flex flex-col items-center gap-2 w-full">
          <div className="text-center">
            <div className="flex justify-center items-baseline">
              <span className="text-[3.8svh]">{khutbah.cleanTime}</span>
              {khutbah.meridiem && (
                <span className="text-[2svh] pl-[0.5svh]">{khutbah.meridiem}</span>
              )}
            </div>
            <p className="text-[2svh] uppercase">Khutbah</p>
          </div>

          <div className="w-[7svh] h-[0.3svh] bg-white/40" />

          <div className="text-center">
            <div className="flex justify-center items-baseline">
              <span className="text-[3.8svh]">{iqamah.cleanTime}</span>
              {iqamah.meridiem && (
                <span className="text-[2svh] pl-[0.5svh]">{iqamah.meridiem}</span>
              )}
            </div>
            <p className="text-[2svh] uppercase">Iqamah</p>
          </div>
        </div>
      </div>
    );
  };

  if (!jummahTimes.length) {
    return (
      <div className="text-center py-4">
        <p className="text-gray-400 text-sm">No Jummah data available</p>
      </div>
    );
  }

  return (
    <div className="text-center px-[5svh]">
      <h2 className="text-[4svh] text-black font-medium mb-[1svh]">JUMU’AH</h2>
      <div
        className={`grid gap-4 justify-center ${
          jummahTimes.length === 1
            ? "grid-cols-1 max-w-xs mx-auto"
            : jummahTimes.length === 2
            ? "grid-cols-2"
            : "grid-cols-3"
        }`}
      >
        {jummahTimes.map(renderJummahBlock)}
      </div>
    </div>
  );
};

export default JummahInfo;